/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from "react";
import { FormattedMessage } from "react-intl";

import { FirstFourApprovers } from "./ApprovalFlowHelpers";
import InvitedApproversModal from "./InvitedApproversModal";

interface ApproverNamesProps {
  approvalLog: any;
}

export default function ApproverNames({ approvalLog }: ApproverNamesProps) {
  const [showInvitedApproversModal, setShowInvitedApproversModal] = useState(false);

  const handleClickOthers = () => () => {
    setShowInvitedApproversModal(true);
  };

  return (
    <div>
      <InvitedApproversModal
        show={showInvitedApproversModal}
        onHide={() => setShowInvitedApproversModal(false)}
        requested_approvers={approvalLog?.requested_approvers}
      />
      <div className="font-medium text-sm text-secondary-v2">
        <FirstFourApprovers approvers={approvalLog?.requested_approvers} />
        {approvalLog?.requested_approvers?.length > 4 && (
          <>
            ,{" "}
            <span className="font-regular text-brand-tertiary-400 cursor-pointer" onClick={handleClickOthers}>
              <FormattedMessage
                id="quote-request.approvalFlow.andMore"
                defaultMessage="and {users} more"
                values={{ users: approvalLog.requested_approvers.length - 4 }}
              />
            </span>
          </>
        )}
      </div>
    </div>
  );
}
